



























import Vue from 'vue';
import ReportTable from '@/components/ReportTable.vue';
import ReportControls, { ReportSpecByWeek, Account } from '@/components/ReportControls.vue';
import axios from 'axios';
import XLSX from 'xlsx';

export default Vue.extend({
  name: 'PostcodeProductMixGeneral',
  components: {ReportControls, ReportTable},
  data() {
    return {
      loading: true,
      spec: {} as ReportSpecByWeek,
      headers: [],
      selectedPeriod: [],
      yearToDate: [],
      selectedPeriodBreakdowns: {} as { [postcode: string]: Array<Array<string | number>> },
      ytdBreakdowns: {} as { [postcode: string]: Array<Array<string | number>> },
    };
  },
  computed: {
    dataUrl(): string {
      const BASE_URL = (process.env.NODE_ENV === 'production') ? '/api' : '//localhost:8000';
      const {depot, from, to} = this.spec;
      return `${BASE_URL}/reports/postcode-product-mix-general/${depot}/${from.year}/${from.week}/${to.year}/${to.week}/`;
    },
  },
  watch: {
    async spec() {
      this.loading = true;
      const response = await axios.get(this.dataUrl, {
        params: {
          account_codes: this.spec.accountCodes.flatMap((a: Account) => a.codes),
        },
      });
      this.headers = response.data.headers;
      this.selectedPeriod = response.data.results.currentWeek;
      this.yearToDate = response.data.results.yearToDate;
      this.loading = false;
    },
  },
  methods: {
    download() {
      const wb = XLSX.utils.book_new();
      const currentWeekSheet = XLSX.utils.table_to_sheet((this.$refs.currentWeek as Vue).$el);
      const yearToDateSheet = XLSX.utils.table_to_sheet((this.$refs.yearToDate as Vue).$el);
      XLSX.utils.book_append_sheet(wb, currentWeekSheet, 'Current Week');
      XLSX.utils.book_append_sheet(wb, yearToDateSheet, 'Year to Date');
      const {depot, from, to} = this.spec;
      XLSX.writeFile(wb, `Postcode Product Mix for Depot ${depot} - ${from.year}${to.week}
      to ${to.year}${to.week}.xlsx`);
    },
    async toggleBreakdown(postcode: { key: string, sort?: { index: number, direction: 'ASC' | 'DESC' } }) {
      if (postcode.key in this.selectedPeriodBreakdowns) {
        this.$delete(this.selectedPeriodBreakdowns, postcode.key);
        this.$delete(this.ytdBreakdowns, postcode.key);
      } else {
        const response = await axios.get(this.dataUrl, {
          params: {
            account_codes: this.spec.accountCodes.flatMap((a: Account) => a.codes),
            pc: postcode.key,
          },
        });
        const idx = postcode.sort?.index ?? 0;
        const descending = postcode.sort?.direction === 'DESC';

        function sortFunc(a: Array<string | number>, b: Array<string | number>) {
          let first;
          let second;
          if (idx >= a.length) {
            // Sort by total
            const aTotal = a.slice(1).reduce((x, y) => (x as number) + (y as number), 0);
            const bTotal = b.slice(1).reduce((x, y) => (x as number) + (y as number), 0);
            first = descending ? bTotal : aTotal;
            second = descending ? aTotal : bTotal;
          } else {
            first = descending ? b[idx] : a[idx];
            second = descending ? a[idx] : b[idx];
          }
          if (typeof first === 'string') {
            return first.localeCompare(second as string, undefined, {numeric: true});
          } else {
            return first - (second as number);
          }
        }

        response.data.results.currentWeek.sort(sortFunc);
        response.data.results.yearToDate.sort(sortFunc);
        this.$set(this.selectedPeriodBreakdowns, postcode.key, response.data.results.currentWeek);
        this.$set(this.ytdBreakdowns, postcode.key, response.data.results.yearToDate);
      }
    },
  },
});
